module.exports = __webpack_public_path__ + "img/sale-out.a6f93a45.png";